import { Samples } from 'containers';
import { useGetActiveSamplesQuery } from 'app/services/samples';
import { Sample } from 'constants/sample';

const Table = () => {
  const { data, isFetching } = useGetActiveSamplesQuery();
  return <Samples type={Sample.TableType.ACTIVE_SAMPLES} data={data} isLoading={isFetching} />;
};

export default Table;